import type { AuthedRequest } from '../auth/AuthProvider';

/** Mirrors /api/v1/virtual-matrix/workstations. */
export interface Workstation {
  id: string;
  name: string;
  created_at: string;
}

export const workstationsKey = ['virtual-matrix', 'workstations'] as const;

export async function listWorkstations(req: AuthedRequest): Promise<Workstation[]> {
  return (await req<{ items: Workstation[] }>('GET', '/api/v1/virtual-matrix/workstations')).items;
}
export const createWorkstation = (req: AuthedRequest, name: string) =>
  req<Workstation>('POST', '/api/v1/virtual-matrix/workstations', { name });
export const deleteWorkstation = (req: AuthedRequest, id: string) =>
  req<null>('DELETE', `/api/v1/virtual-matrix/workstations/${encodeURIComponent(id)}`);

/** localStorage key holding this browser's binding: {"id","name"}. */
export const WORKSTATION_KEY = 'monitoring:workstation';

export interface Binding {
  id: string;
  name: string;
}

export function readBinding(): Binding | null {
  try {
    const raw = localStorage.getItem(WORKSTATION_KEY);
    if (!raw) return null;
    const v = JSON.parse(raw) as Partial<Binding> | null;
    return v && typeof v.id === 'string' && typeof v.name === 'string'
      ? { id: v.id, name: v.name }
      : null;
  } catch {
    return null;
  }
}

export function writeBinding(b: Binding | null) {
  try {
    if (b) localStorage.setItem(WORKSTATION_KEY, JSON.stringify({ id: b.id, name: b.name }));
    else localStorage.removeItem(WORKSTATION_KEY);
  } catch {
    /* storage unavailable: the binding just is not remembered */
  }
}
